import * as React from 'react';
import { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { textOverflow, whiteSpace } from '../utils/customPropStyles';
import Chevron from './Chevron';
import ShareclassColumnValue from './ShareclassColumnValue';

const ShareclassRow = styled<any, any>('tr')`
    ${propStyles};
`;

ShareclassRow.defaultProps = {
    cursor: "pointer",
    bgColor: "white",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "none none solid none",
    alternated: {
        bgColor: "gray100"
    },
    hover: {
        bgColor: "gray200"
    }
};

export const ShareclassColumn = styled<any, any>('td')`
    ${propStyles};
    ${textOverflow};
    ${whiteSpace};
`;

ShareclassColumn.defaultProps = {
    paddingX: "sm",
    paddingY: "md",
    fontSize: "sm",
    overflow: " hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};

@observer
class ShareclassRows extends Component<any, any> {

    render() {
        const { theme, alternated, rowExpandable, selectedGroupMap, children, ...shareClass } = this.props;

        return (
            <Fragment>
                <ShareclassRow
                    data-alternated={alternated}
                    data-selected={shareClass.expanded}
                    onClick={rowExpandable ? shareClass.toggleExpanded : () => null}
                    cursor={rowExpandable ? "pointer" : "auto"}
                    {...theme.ShareclassRow}
                >
                    {
                        rowExpandable &&
                        <ShareclassColumn
                            paddingX="0"
                            width="40px"
                            textAlign="center"
                            {...theme.ShareclassColumnExpand}
                        >
                            <Chevron
                                direction={shareClass.expanded ? "down" : "right"}
                                iconSize="1.4em"
                                {...theme.ShareclassColumnExpandIcon}
                            />
                        </ShareclassColumn>
                    }
                    {
                        shareClass.columns.map((column, index) => (
                            <ShareclassColumn
                                key={`${column.type}-${index}`}
                                textAlign={column.textAlign || 'center'}
                                width={column.width}
                                overflow={column.type === "document" ? "visible" : "hidden"}
                                {...theme.ShareclassColumn}
                            >
                                <ShareclassColumnValue
                                    shareClass={shareClass}
                                    column={column}
                                    columnIndex={index}
                                    selectedGroupMap={selectedGroupMap}
                                />
                            </ShareclassColumn>
                        ))
                    }
                </ShareclassRow>
                {
                    shareClass.expanded && (
                        <tr>
                            <td colSpan={rowExpandable ? shareClass.columns.length + 1 : shareClass.columns.length}>{children}</td>
                        </tr>
                    )
                }
            </Fragment>
        );
    }
}

export default withTheme(ShareclassRows) as any;


// WEBPACK FOOTER //
// ./src/Components/ShareclassRows.tsx